module.exports = __webpack_public_path__ + "static/media/otp_icon.c6d4c24e.svg";